import { useState } from "react";
import { useParams } from "react-router-dom";

import { Screenshot } from "~/api/Api";
import Modal from "~/components/ui/modal/Modal";
import { PAGE_TITLES } from "~/configs/pageTitles";
import { useSiteContext } from "~/contexts/SiteContext.tsx";
import { usePageTitle } from "~/hooks/usePageTitle";

import Analytics from "../../components/dashboard/analytics/Analytics";
import Breadcrumbs from "../../components/ui/breadcrumbs/Breadcrumbs";
import styles from "./styles.module.scss";

const AnalyticsPage = () => {
  usePageTitle(PAGE_TITLES.analytics);

  const { id } = useParams();
  const fakeBreadcrumbs = [
    {
      title: PAGE_TITLES.dashboard,
      link: "/",
    },
    {
      title: PAGE_TITLES.analytics,
      link: `/sites/${id}`,
    },
  ];

  const siteContext = useSiteContext();
  const screenshotDesktop = siteContext?.site?.site?.screenshot_desktop;
  const desktopPreviewUrl = (screenshotDesktop as Screenshot)?.thumb;

  const screenshotMobile = siteContext?.site?.site?.screenshot_mobile;
  const mobilePreviewUrl = (screenshotMobile as Screenshot)?.thumb;

  const [isDesktopModalOpen, setIsDesktopModalOpen] = useState<boolean>(false);
  const [isMobileModalOpen, setIsMobileModalOpen] = useState<boolean>(false);

  return (
    <div className={styles.page}>
      <div className={styles.wrapper}>
        <div>
          <h1 className={styles.title}>{PAGE_TITLES.analytics}</h1>
          <Breadcrumbs fakeBreadcrumbs={fakeBreadcrumbs} />
        </div>
        {(desktopPreviewUrl || mobilePreviewUrl) && (
          <div>
            {mobilePreviewUrl && (
              <>
                <img
                  src={mobilePreviewUrl}
                  alt="Site Screenshot Preview Mobile"
                  className={styles.mobileScreenshotImage}
                  onClick={() => setIsMobileModalOpen(true)}
                />

                <Modal
                  isOpen={isMobileModalOpen}
                  closeModal={() => setIsMobileModalOpen(false)}
                  modalLabel={<h3>Mobile Screenshot</h3>}
                  width="80vw"
                  height="80vh"
                >
                  <div className={styles.imageWrapper}>
                    <img
                      src={
                        typeof screenshotMobile === "string"
                          ? screenshotMobile
                          : screenshotMobile?.url
                      }
                      alt="Site Screenshot Preview Mobile"
                      className={styles.mobilePopupScreenshotImage}
                    />
                  </div>
                </Modal>
              </>
            )}
            {desktopPreviewUrl && (
              <>
                <img
                  src={desktopPreviewUrl}
                  alt="Site Screenshot Preview Desktop"
                  className={styles.desktopScreenshotImage}
                  onClick={() => setIsDesktopModalOpen(true)}
                />

                <Modal
                  isOpen={isDesktopModalOpen}
                  closeModal={() => setIsDesktopModalOpen(false)}
                  modalLabel={<h3>Desktop Screenshot</h3>}
                  width="80vw"
                  height="80vh"
                >
                  <div className={styles.imageWrapper}>
                    <img
                      src={
                        typeof screenshotDesktop === "string"
                          ? screenshotDesktop
                          : screenshotDesktop?.url
                      }
                      alt="Site Screenshot Preview Desktop"
                      className={styles.desktopPopupScreenshotImage}
                    />
                  </div>
                </Modal>
              </>
            )}
          </div>
        )}
      </div>
      <Analytics />
    </div>
  );
};
export default AnalyticsPage;
